<template>

    <DBox 
      :id="'cmp-distribution-statement-statement_setup'"
      :addButton="false"
    >
    <div class="ut-fc">
        <TextField2
            style="flex:1"
            id="description"
            :placeholder="$dft.capHead($t('description'))"
            :label="$dft.capHead($t('description'))"
            :value="selectedStatementDetails.statement.description"
           
           
            @blur=" e => onTextFieldValueChange(e)"
        />
        <Dropdown2
          style="flex:1"
          id="digital_physical"
          :label="$dft.capHead($t('channel'))"
          :placeholder="'Select ' + $dft.capHead($t('channel'))"
          :disabled="true"
          :options="channelTV"
          :selected="channelTV.find(e=>e.value==selectedStatementDetails.statement.digital_physical)"
          v-on:selectedChange="e => onDropdownChange('digital_physical', e)"
        />
        <TextField2
            style="flex:1"
            id="statement_year"
            class="m1"
            :placeholder="$dft.capHead('year')"
            :label="$dft.capHead('year')"
            :value="selectedStatementDetails.statement.statement_year"
            :disabled="true"
            @blur=" e => onTextFieldValueChange(e) "
        />
        <Dropdown2
          style="flex:1"
          id="statement_period_txt"
          :label="$dft.capHead($t('period'))"
          :placeholder="'Select ' + $dft.capHead($t('period'))"
          :disabled="isDiabled"
          :options="periodTV"
          :selected="periodTV.find(e=>e.value==selectedStatementDetails.statement.statement_period_txt)"
          v-on:selectedChange="e => onDropdownChange('statement_period_txt', e)"
        />
        <Dropdown2
          style="flex:1"
          id="currency_id"
          :label="$dft.capHead($t('currency'))"
          :placeholder="'Select ' + $dft.capHead($t('currency'))"
          :disabled="true"
          :options="currencyTV"
          :selected="currencyTV.find(e=>e.value==selectedStatementDetails.statement.currency_id)"
          v-on:selectedChange="e => onDropdownChange('currency_id', e)"
          :bb="'none'"
        />
       
    </div>
        
       
   
    </DBox> 
</template>
<script>

import {
  createTV,
  tv,
} from "../../../../models/text-value.model";



export default {
  props: {

    selectedStatementDetails:{
      type:Object
    },


  },

  data: function() {
    return {
     textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },
      description:'',
      statement_year:'',
      digital_physical:null,
      statement_period_txt:null,
      currency_id:null
  
    };
  },
  methods:{
    onTextFieldValueChange:function (e ) {
      const payload={ 
                      name:e.name ,
                      value:e.value,
                    
                    }
      this.$emit('changed',payload)
      console.log("WERERTYUPOIUN",payload)
    },
    onDropdownChange:function(name,e){
      const payload={
                      name:name ,
                      value:e.value,
                    }
      this.$emit('changed',payload)
      console.log("WERERTYUPOIUN",payload)
    },


  },
  computed:{
    invoice_id:function(){
      return this.selectedStatementDetails?.statement?.invoice_id||''
    },

    isDiabled:function(){
      return this.invoice_id!=''?true:false
    },

    periodTV:function(){
      return[
          {text:'M1',value:'M1'},
          {text:'M2',value:'M2'},
          {text:'M3',value:'M3'},
          {text:'M4',value:'M4'},
          {text:'M5',value:'M5'},
          {text:'M6',value:'M6'},
          {text:'M7',value:'M7'},
          {text:'M8',value:'M8'},
          {text:'M9',value:'M9'},
          {text:'M10',value:'M10'},
          {text:'M11',value:'M11'},
          {text:'M12',value:'M12'},
          {text:'Q1',value:'Q1'},
          {text:'Q2',value:'Q2'},
          {text:'Q3',value:'Q3'},
          {text:'Q4',value:'Q4'},
          {text:'S1',value:'S1'},
          {text:'S2',value:'S2'},
          {text:'Y',value:'Y'},
      ]
    },
    channelTV:function(){
        return [
          { text:'Digital',value:'digital' },
          { text:'Physical',value:'physical' },
          { text:'Costs',value:'costs' },
          { text:'Third Party',value:'thirdparty' },
          { text:'Performance',value:'performance' },
          { text:'Other Income',value:'income' },
          { text:'Multi',value:'multi' },
        
        ]
    },
   
    currencyTV:function(){
     
      return createTV(this.selectedStatementDetails?.currencies,'currency_iso','currency_id');
    }
  }

}
</script>
<style lang="scss">
.cmp-licencing-licence-accounts-sidewindow-account_setup{
  
  .flex-container {
    display:flex;
    padding: 10px;
    .flex-item{
      flex:0.25;
      padding:10px
    }
  }

}
</style>
